import { PaymentMethod, PaymentMethods } from 'src/constants/PaymentMethod';

export function isCardOnDeliveryPayment(paymentMethod?: PaymentMethod): boolean {
    return paymentMethod === PaymentMethods.CARD_ON_DELIVERY;
}
